module.exports = __webpack_public_path__ + "img/gem.e1d9accd.png";